var app;

app = window.App || (window.App = {});

app.ApplicationMarket = (function() {
  function ApplicationMarket() {}

  ApplicationMarket.prototype.updateCount = function() {
    var applications, selector, text;
    applications = $('tbody#applications tr').size();
    selector = applications === 1 ? 'one' : 'other';
    text = applications + " ";
    text += $(".pending_applications_info ." + selector).text();
    return $('.pending_applications_info span:eq(0)').html(text);
  };

  ApplicationMarket.prototype.moveElementToBottom = function(elementId, targetId, callback) {
    var $element, $target, left, leftOld, top, topOld;
    $target = $('#' + targetId);
    left = $target.offset().left;
    top = $target.offset().top + $target.height();
    $element = $('#' + elementId);
    leftOld = $element.offset().left;
    topOld = $element.offset().top;
    $element.children().each(function(i, c) {
      var $c;
      $c = $(c);
      return $c.css('width', $c.width());
    });
    $element.css('left', leftOld);
    $element.css('top', topOld);
    $element.css('position', 'absolute');
    return $element.animate({
      left: left,
      top: top
    }, 300, callback);
  };

  return ApplicationMarket;

})();
